import css from 'styled-jsx/css';

const styles = css.global`.banner_desk {
  display: none;
}

.banner_mobile {
  background-color: #010101;
  padding-bottom: 20px;
}

.img-container {
  position: relative;
  width: 100%;
  height: 340px;
}


.img-container img {
  object-fit: cover;
  width: 100%;
  height: 100%;
}

.banner_disclaimer {
  color: #222;
  font-family: "SantanderHeadline";
  font-size: 15px;
  text-align: center;
  margin-top: 20px;
}

.banner_disclaimer a {
  font-family: "SantanderHeadline";
  font-size: 15px;
  color: #CC0000;
}

.banner_disclaimer a:hover {
  text-decoration: underline;
}

#simular-banner-mobile {
  margin: -65px auto 0;
  width: 160px;
  height: 44px;
  z-index: 2;
  position: relative;
}

@media (min-width: 992px) {
  .banner_mobile {
    display: none;
  }

   .banner_desk {
    background-image: linear-gradient(360deg, rgba(255,255,255,0) 22%, #CC0000 22%, #CC0000 100%);
    display: flex;
    margin-bottom: 0px;
  }

  #simular-banner-desktop {
    position: absolute;
    bottom: 25px;
    left: 135px;
  }
}

@media (min-width: 1200px) {
  #simular-banner-desktop {
    left: 153px;
  }
}

@media (min-width: 1400px) {
  #simular-banner-desktop {
    left: 203px;
  }
}
`;

export default styles;